import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  showDashboardVimeoModal: false,
};

const togglersSlice = createSlice({
  name: "togglersSlice",
  initialState,
  reducers: {
    toggleDashboardVimeoModal: (state, actions) => {
      state.showDashboardVimeoModal = actions?.payload?.showModal;
    },
  },
});

export const { toggleDashboardVimeoModal } = togglersSlice.actions;

export default togglersSlice.reducer;
